/**
 * Typed failures of the audio engine (W1-14). Each carries a translatable `reason` (namespace 'audio', see
 * audio.messages.ts); `message` is the English developer text.
 */

import type { MessageRef } from '../core/util/types';
import { AUDIO_MESSAGES, type AudioMessageId } from './audio.messages';

export type AudioErrorCode = AudioMessageId;

export class AudioEngineError extends Error {
  readonly code: AudioErrorCode;
  readonly reason: MessageRef;

  constructor(code: AudioErrorCode, detail?: string, options?: { readonly cause?: unknown }) {
    super(detail === undefined ? AUDIO_MESSAGES[code] : `${AUDIO_MESSAGES[code]} (${detail})`, options);
    this.name = 'AudioEngineError';
    this.code = code;
    this.reason = { key: `audio.${code}` };
  }
}

export function isAudioEngineError(e: unknown, code?: AudioErrorCode): e is AudioEngineError {
  return e instanceof AudioEngineError && (code === undefined || e.code === code);
}
